import type { PostHogConfig } from "posthog-js";

/**
 * PostHog deprecated event ingestion on the dashboard domain (eu.posthog.com).
 * Events must be sent to the dedicated ingestion subdomain (eu.i.posthog.com);
 * ui_host keeps the toolbar/session-recording links pointing at the dashboard.
 * See FINVIA/mono#9379.
 *
 * config.analytics.postHog.apiHost (REACT_APP_POSTHOG_API_HOST) is read first,
 * per the existing config pattern in src/config/index.ts - this only changes
 * the fallback used when that env var is unset.
 */
export const POSTHOG_INGESTION_HOST = "https://eu.i.posthog.com";
export const POSTHOG_UI_HOST = "https://eu.posthog.com";

// Partial<PostHogConfig> (rather than a hand-rolled type) gives us
// excess-property checking against posthog-js's real init options.
export const getPostHogInitOptions = (
  apiHost?: string
): Partial<PostHogConfig> => ({
  api_host: apiHost || POSTHOG_INGESTION_HOST,
  ui_host: POSTHOG_UI_HOST,
  autocapture: true,
  capture_pageview: true,
});
